import { observer } from 'mobx-react-lite'
import { Avatar } from '@/components/Avatar'
import { FormGroupContainer } from '@/components/FormContainer'
import { FormRow } from '@/components/Form'
import {
  CustomSelect,
  SingleItemSelectedDefault,
} from '@/components/inputs/CustomSelect'
import { useCustomSelectStateFromItemSource } from '@/components/inputs/item-source-hook'
import { SearchResultItem } from '@/components/inputs/SearchResultItem'
import { JoinWorkspaceAsAdminDialog } from '@/features/user-management/JoinWorkspaceAsAdminDialog'
import { type JoinWorkspaceAsAdminDialogViewModel } from './JoinWorkspaceAsAdminDialogViewModel'

export interface JoinWorkspaceAsAdminDialogContainerProps {
  vm: JoinWorkspaceAsAdminDialogViewModel
}

export const JoinWorkspaceAsAdminDialogContainer = observer(
  function JoinWorkspaceAsAdminDialogContainer({
    vm,
  }: JoinWorkspaceAsAdminDialogContainerProps) {
    const selectProps = useCustomSelectStateFromItemSource({
      itemSource: vm.searchWorkspaces,
      debounce: 300,
    })

    const error = vm.validation.getError('workspace')

    return (
      <JoinWorkspaceAsAdminDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
      >
        <FormRow>
          <FormGroupContainer label="Workspace" error={error}>
            <CustomSelect
              {...selectProps}
              status={error ? 'danger' : 'default'}
              placeholder="Select workspace"
              itemToString={(v) => v?.name ?? ''}
              value={vm.workspace ?? undefined}
              onChange={vm.setWorkspace}
              multi={false}
              isDisabled={vm.submit.pending}
              testId="join-workspace-as-admin-workspace-selector"
              renderItem={(itemProps) => (
                <SingleItemSelectedDefault
                  {...itemProps}
                  visual={
                    <Avatar
                      size={24}
                      subject={{
                        avatar: itemProps.item.branding.logos.icon,
                      }}
                    />
                  }
                />
              )}
              renderSearchItem={({ item, ...itemProps }) => (
                <SearchResultItem
                  {...itemProps}
                  visual={
                    <Avatar
                      size={24}
                      subject={{
                        avatar: item.branding.logos.icon,
                      }}
                    />
                  }
                >
                  {item.name}
                </SearchResultItem>
              )}
            />
          </FormGroupContainer>
        </FormRow>
      </JoinWorkspaceAsAdminDialog>
    )
  },
)
